module.exports = __webpack_public_path__ + "img/iconsquare-popup-success.33002e8d.png";